import { Grid, makeStyles, Typography } from '@material-ui/core';
import FullscreenDialog from 'components/FullscreenDialog';
import Table from 'components/Table/Table';
import DatasetDTO from 'dto/DatasetDTO';
import React from 'react';
import repo from 'services/repositories';

const useStyles = makeStyles(() => ({
  dialog: {
    padding: 0
  },
  table: {
    margin: 0,
    height: '100%',
    boxShadow: 'none',
    marginTop: -48 // height of close icon
  },
  empty: {
    height: '100%'
  }
}));

interface DataTableDialogProps {
  dataset: DatasetDTO,
  title: string,
  open: boolean,
  onClose: () => void
}

const DataTableDialog = (props: DataTableDialogProps) => {
  const {dataset, title, open, onClose} = props;

  const styles = useStyles();
  const [data, setData] = React.useState<Record<string, string>[]>([]);
  const [loaded, setLoaded] = React.useState<boolean>(false);

  React.useEffect(() => {
    if(dataset) {
      setLoaded(false);
      repo.getData(dataset.id).then(d => {
        setData(d);
        setLoaded(true);
      });
    }
  }, [dataset && dataset.id]);



  return <FullscreenDialog
    className={styles.dialog} 
    onClose={onClose}
    open={open && loaded}
  >
    {data.length > 0 && <Table
      classes={{root: styles.table, }}
      data={data}
      headers={Object.keys(data[0])}
      idKey={Object.keys(data[0])[0]}
      open
      title={title}
    />}
    {data.length === 0 && <Grid
      alignItems='center'
      className={styles.empty}
      container
      justifyContent='center'
    >
      <Typography variant='h3'>Dataset is empty</Typography>
    </Grid>}
  </FullscreenDialog>
}

export default DataTableDialog;